import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useUOMOptionsQuery } from "hooks/useUOMQuery";
import { palletTypeOptions } from "layouts/views/common/options";
import { useState } from "react";
import { ReadOnlyTextField } from "ui-components/Form";
import { TitleField } from "ui-components/Form";

import { FormTitle, Text, SelectField } from "ui-components/Form";

function SKUPackTypeInfo({
  skuOptions = [],
  vendorOptions = [],
  formRender,
  control,
  errors,
  mode = "ADD",
  lotAttribute = true,
  // Value as loaded from the server (NOT the live in-progress form value - upmCase must not
  // flip to read-only mid-typing before the user submits).
  initialUpmCase,
}) {
  const [uomOpt, setUOMOpt] = useState([]);
  const [uomWeightOpt, setUOMWeightOpt] = useState([]);
  useUOMOptionsQuery({
    onSuccess: (data) => {
      const unit = data.data.data.filter((x) => x.uomType === "Unit");
      const weight = data.data.data.filter((x) => x.uomType === "Weight");
      setUOMOpt(unit.map((x) => x.uomid));
      setUOMWeightOpt(weight.map((x) => x.uomid));
    },
  });
  return (
    <MDBox>
      <FormTitle
        title={mode === "EDIT" ? "Edit SKU Pack Type Information" : "SKU Pack Type Information"}
      />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, size, editable, ...data } = property;
              const xs = size ? size : 3;
              let fieldProps = {
                ...data,
                control,
                errors,
                ...(disabled && { disabled }),
                ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
              };
              if (lotAttribute === false) {
                switch (fieldProps.name) {
                  case "baseUOM":
                  case "innerpackUOM":
                  case "upmInnerpack":
                  case "caseUOM":
                  case "palletUOM":
                  case "upmPallet":
                  case "palletType":
                    // fieldProps["disabled"] = true;
                    // fieldProps["type"] = "text";
                    fieldProps["type"]="readonly"
                    break;
                  case "upmCase":
                    // upmCase only gets locked read-only when it was ALREADY a real (>0) value
                    // on load. If it's still 0 (never actually filled in), keep it editable even
                    // though the pack type is otherwise in use / not editable. Uses the initial
                    // server value, not the live form value - typing a number in must not flip
                    // the field read-only before the user submits.
                    if (Number(initialUpmCase) > 0) {
                      fieldProps["type"] = "readonly";
                    }
                    break;
                }
              }
              let renderField;
              switch (fieldProps.type) {
                case "text":
                case "number":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "readonly":
                  renderField = <ReadOnlyTextField field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  switch (data.name) {
                    case "skuCode":
                      options = skuOptions;
                      break;
                    case "vendorCode":
                      options = vendorOptions;
                      break;
                    case "palletType":
                      options = palletTypeOptions;
                      break;
                    case "baseUOM":
                    case "innerpackUOM":
                    case "caseUOM":
                    case "cubicUOM":
                    case "palletUOM":
                      options = uomOpt;
                      break;
                    case "grossWeightUOM":
                    case "netWeightUOM":
                      options = uomWeightOpt;
                      break;
                  }
                  renderField = <SelectField field={fieldProps} options={options} />;
                  break;
                case "title":
                  renderField = <TitleField label={data.label} />;
                  break;
              }

              return (
                <Grid item xs={xs} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default SKUPackTypeInfo;
